interface GateVignetteProps {
  alt: string;
}

export function GateVignette({ alt }: GateVignetteProps) {
  return (
    <img
      src="/gate-image.webp"
      alt={alt}
      className="max-w-full max-h-full object-contain"
    />
  );
}
